// `cn(...)` helper — Tailwind class merging with sane conflict
// resolution. tailwind-merge handles "p-2 p-4 → p-4" so component
// callers can override defaults without thinking about ordering.
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
